module.exports = __webpack_public_path__ + "static/media/bandcamp.c23843b0.png";